import React from 'react';
import { observer } from 'mobx-react';
import { advSearchState } from 'Stores/advSearch';
import companySearchState from 'Stores/companySearch';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import userDetail from 'Stores/userDetail';
import * as CONSTANTS from 'Utils/constants';
import { Utils } from 'Utils/utils';
import { ReactComponent as LockIcon } from 'Assets/svg/lock.svg';
import { personalisedOnboardingState } from 'Stores/personalisedOnboardingState';
import advSearchFiltersState from 'Stores/advSearchFilters';
import { CompanyName } from './companyName';
import { EmpCount } from './empCount';
import { Revenue } from './revenue';
import { ExcludeCompanyCSV } from './excludeCompanyCSV';
import { LeadTitle } from './leadTitle';
import { EmailPreference } from './emailPreference';
import { OptionsCompany } from './optionsCompany';

import { Location } from './location';
import {
  ContactFilterPopup,
  contactFilterPopupState,
} from './contactFilterPopup';
import { ReactComponent as PlusIcon } from '../../../../assets/svg/plus-icon.svg';
import { ReactComponent as DropDownIcon } from '../../../../assets/svg/down-arrow-icon.svg';
import { IndustrySectorSearch } from './industrySectorSearch';
import { Technologies } from './technologies';
import Dropdown from 'Components/common/dropdown';
import FilterDropdown from './filterDropdown';


const { PERSONALIED_ONBOARDING_FLOWS } = CONSTANTS;
const { TARGETED_ACCOUNTS, AD_AUDIENCE_LIST } = PERSONALIED_ONBOARDING_FLOWS;

const FIlterFacets = observer(props => {
  const { currentTab = 'contact' } = props;
  const { isFreeTrial, featureFlags } = userDetail;
  const {
    LOCATION_PREFERENCE = false,
    COMPANY_CSV_EXPORT_INTERNAL = false,
    ADVANCED_FILTERS = false,
  } = featureFlags;

  const {
    isPersonalisedOnboardingFlow,
    onboardingCurrentStep,
  } = personalisedOnboardingState;

  const localCurrIndustrySearch = Utils.getLocalStorage(
    currentTab === 'contact'
      ? 'showIndustrySearch'
      : 'showIndustrySearchCompany',
  );

  const showAllFilter = contactFilterPopupState.showPopup;
  const showAll = () => {
    Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_VIEW_ALL_FILTERS_CLICKED, {
      btnSource: 'filter section',
    });
    if (localCurrIndustrySearch !== null)
      Utils.setLocalStorage('popupIndustrySearch', localCurrIndustrySearch);
    else Utils.removeLocalStorage('popupIndustrySearch');
    contactFilterPopupState.setShowPopup(true);
  };

  const clearUpgradePopup = event => {
    const eleList = document.getElementsByClassName('show-upgrade-popup');
    if (eleList !== undefined && eleList.length > 0)
      for (let i = 0; i < eleList.length; i += 1)
        eleList[i].classList.remove('show-upgrade-popup');
    const maskEle = document.getElementsByClassName('upgradePopupMask')[0];
    maskEle.classList.remove('showMask');
  };

  const handleUpgrade = () => {
    Utils.upgradeNowClick('Company Search');
  };

  return currentTab === 'contact' ? (
    <>
      <div
        className={`filter-parents${
          showAllFilter ? ' all-filters-enabled' : ''
        }`}
      >
        <div className="upgradePopupMask" onClick={clearUpgradePopup} />
        <div className="top-filter-group">
          <Location filterInPage placeholderText="Location" />
          <IndustrySectorSearch
            filterInPage
            parentSelectorId="contactTabPage"
          />
          <FilterDropdown
            placeholderText="Level"
            suggestionKey="level"
            listValues={advSearchFiltersState.filterListValues.level}
            filterInPage
          />

          <FilterDropdown
            placeholderText="Department"
            suggestionKey="dept"
            listValues={advSearchFiltersState.filterListValues.department}
            filterInPage
          />
          <Dropdown
            animateDropdown
            wrapperClassName="dropdown-section email-status-section"
            toggleElement={
              <div className="dropdown-box">
                <span>Email Status</span>
                <DropDownIcon
                  className="dropdown-icon plus-icon"
                  width={14}
                  height={14}
                />
              </div>
            }
          >
            <EmailPreference filterInPage />
          </Dropdown>
        </div>
        {ADVANCED_FILTERS && (
          <>
            <CompanyName filterInPage {...props} />
            <LeadTitle filterInPage allowExcludeFilter />
            <EmpCount filterInPage />
            <Revenue filterInPage />
            <Technologies filterInPage />
          </>
        )}
      </div>
      <div className="show-all-filters" onClick={showAll}>
        View all filters
      </div>
      <ContactFilterPopup />
    </>
  ) : (
    <div className="filter-parents">
      <div className="upgradePopupMask" onClick={clearUpgradePopup} />

      <span>
        {(isPersonalisedOnboardingFlow === TARGETED_ACCOUNTS ||
          isPersonalisedOnboardingFlow === AD_AUDIENCE_LIST) &&
        onboardingCurrentStep === 1 ? (
          <>
            <div className="top-filter-group">
              <Location filterInPage placeholderText="Location" {...props} />
              <IndustrySectorSearch
                filterInPage
                parentSelectorId="companyTabPage"
                {...props}
              />
              <CompanyName filterInPage {...props} />
              <Technologies filterInPage {...props} />
              <EmpCount filterInPage {...props} />
              <Revenue filterInPage {...props} />

              <ExcludeCompanyCSV filterInPage {...props} />
            </div>

            <OptionsCompany filterInPage {...props} />
          </>
        ) : (
          <>
            <Location filterInPage placeholderText="Location" {...props} />
            <IndustrySectorSearch
              filterInPage
              parentSelectorId="companyTabPage"
              {...props}
            />
            <div
              className={`${!ADVANCED_FILTERS ? ' disabled-filter-wrap' : ''}`}
            >
              <div className="lock-heading">
                More Filters
                <LockIcon className="dropdown-icon plus-icon lock-icon" />
              </div>
              <div className="disabled-info-wrap">
                Smart-segment with awesome filters.{' '}
                <span onClick={handleUpgrade}>Upgrade Now!</span>
              </div>
              <div className="upgradePopupMask" onClick={handleUpgrade} />
              <CompanyName filterInPage {...props} />
              <Technologies filterInPage {...props} />
              <EmpCount filterInPage {...props} />
              <Revenue filterInPage {...props} />

              <ExcludeCompanyCSV filterInPage {...props} />

              <OptionsCompany filterInPage {...props} />
            </div>
          </>
        )}
      </span>
    </div>
  );
});

export { FIlterFacets };
export default { FIlterFacets };
